import Seo from '../../components/Seo';
import { useAuth } from '../../context/AuthContext';
import { Field } from '../../components/ui';
import { Link } from 'react-router-dom';

export default function Profile() {
  const { user } = useAuth();
  const member = user?.member;

  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <Seo title="My Profile" />
      <h1 className="font-display text-2xl font-bold">My Profile</h1>

      <div className="card flex items-center gap-4 p-6">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-maroon-700 text-2xl font-bold text-gold-400">
          {user?.name?.[0]}
        </div>
        <div>
          <p className="text-lg font-semibold text-ink">{user?.name}</p>
          {/* The username is the sign-in identity, so it leads here. */}
          <p className="font-mono text-sm text-ink-muted">
            {user?.username ? `@${user.username}` : 'No username set'}
          </p>
          <span className="pill-maroon mt-1 capitalize">{user?.role}</span>
        </div>
      </div>

      <div className="card space-y-5 p-6">
        <p className="text-sm text-ink-muted">
          Your account details are read-only here. Contact an administrator to update your
          membership record or change your username.
        </p>
        <div className="grid gap-4 sm:grid-cols-2">
          <Field label="Full name">
            <input className="input" value={user?.name || ''} readOnly />
          </Field>
          <Field
            label="Username"
            hint="You sign in with this. An administrator sets and changes it."
          >
            <input
              className="input bg-surface-alt"
              value={user?.username || 'Not set'}
              readOnly
              autoCapitalize="none"
              spellCheck="false"
            />
          </Field>
          <Field label="Email" hint="Used for notifications and password resets, not for signing in.">
            <input className="input" value={user?.email || 'Not set'} readOnly />
          </Field>
          {member && (
            <>
              <Field label="Club">
                <input className="input" value={member.club?.name || member.club_name || '—'} readOnly />
              </Field>
              <Field label="Position">
                <input className="input" value={member.position || member.title || '—'} readOnly />
              </Field>
            </>
          )}
        </div>
        <div className="border-t border-cream-300 pt-4">
          <Link to="/member/password" className="btn-outline">
            Change password
          </Link>
        </div>
      </div>
    </div>
  );
}
